import { useEffect, useState } from "react";
import { CustomersFileType } from "../Common/Types/types";
import { orderBy } from "@progress/kendo-data-query";
import { Grid, GridCellProps, GridColumn } from "@progress/kendo-react-grid";
import { Button } from "@progress/kendo-react-buttons";

interface HistoryGridProps {
  data: CustomersFileType[] | null;
}
const DiagramHistoryGrid = (props: HistoryGridProps) => {
  const initialSort: any = [
    {
          field: "modifiedDate",
      dir: "desc",
    },
  ];

  const [data, setData] = useState<CustomersFileType[]>([]);
  const [sort, setSort] = useState(initialSort);

  const downloadDiagram = (fileUrl: string) => {
    const link = document.createElement("a");
    link.href = fileUrl;
    //link.target = "_blank";
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);

    //fetch(fileUrl)
    //    .then(response => response.blob())
    //    .then(blob => {
    //        // Create a new FileReader innstance
    //        const reader:any = new FileReader;

    //        // Add a listener to handle successful reading of the blob
    //        reader.addEventListener('load', () => {
    //            const image:any = new Image;

    //            // Set the src attribute of the image to be the resulting data URL
    //            // obtained after reading the content of the blob

    //            var link:any = document.createElement("a");
    //            // If you don't know the name or want to use
    //            // the webserver default set name = ''
    //            link.setAttribute('download', 'file.gif');
    //            link.href = reader.result;
    //            document.body.appendChild(link);
    //            link.click();
    //            link.remove();

    //        });

    //        // Start reading the content of the blob
    //        // The result should be a base64 data URL
    //        reader.readAsDataURL(blob);
    //    });
  };

  useEffect(() => {
    if (props.data != null) {
      setData(props.data);
    }
  }, [props.data]);

  if (data == null) {
    return null; //<div>No data found for selected filters</div>;
  }

  const customDownloadCell = (props: GridCellProps) => {
    return (
      <td>
        <Button onClick={() => downloadDiagram(props.dataItem.url)}>
          Download Diagram
        </Button>
      </td>
    );
  };
  return (
    <Grid
      data={orderBy(data, sort)}
      sortable={true}
      sort={sort}
      onSortChange={(e) => {
        setSort(e.sort);
      }}
      resizable={true}
    >
      <GridColumn field="name" title="File Name" width="220px" />
      <GridColumn
        field="modifiedDate"
        title="Modified Date (UTC)"
        filter="date"
        width="150px"
      />
      <GridColumn field="modifiedBy" title="Modified By" width="250px" />
      <GridColumn field="comment" title="Comment" width="250px" />
      <GridColumn width="150px" cell={customDownloadCell} />
    </Grid>
  );
};
export default DiagramHistoryGrid;
